// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as PpApiModel from "../entity/PpApiModel.bs.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Date$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PpSubscriptionStatus from "../entity/PpSubscriptionStatus.bs.js";

function execute(json) {
  var param = DeccoUtils$Catalyst.resolveResult(PpApiModel.t_decode(json), "PpReportStateMapper.re");
  return {
          subscription_logs: Belt_List.map(param.subscriptions, (function (param) {
                  var expiry_date = param.expiry_date;
                  return {
                          start_date: Date$Catalyst.make(param.start_date, "DD/MM/YYYY"),
                          expiry_date: expiry_date !== undefined ? Caml_option.some(Date$Catalyst.make(expiry_date, "DD/MM/YYYY")) : undefined,
                          expiry_reason: param.expiry_reason,
                          subscription_price: param.subscription_price,
                          payment_reference_number: param.payment_reference_number,
                          status: PpSubscriptionStatus.fromString(param.status),
                          scheme_name: param.scheme_name,
                          end_date: Date$Catalyst.make(param.end_date, "DD/MM/YYYY")
                        };
                })),
          next_offset_ts: param.next_offset_ts
        };
}

export {
  execute ,
  
}
/* Date-Catalyst Not a pure module */
